var Iter = {
	getValue: function(o, prop){
		var parts = prop.split(".");
		var val = o;
		for( var i = 0; i < parts.length; i++ ){
			if(val === null || val === undefined) return null;
			val = val[parts[i]];
		}
		return val;
   },
	find: function(a, f){
		for (var i = 0; i < a.length; i++) {
			if( f(a[i], i, a) ) return a[i];
		};
		return null;
	},
	findAll: function(a, f){
		var out = [];
		for (var i = 0; i < a.length; i++) {
			if( f(a[i], i, a) ) out.push(a[i]);
		};
		return out;
	},
	findByProp: function(a, prop, val){
		for (var i = 0; i < a.length; i++) {
			if( Iter.getValue(a[i], prop) == val ) return a[i];
		};
		return null;
	},
	findById: function(a, id){
		return Iter.findByProp(a, "id", id);
	},
	findAllByProp: function(a, prop, val){
		var out = [];
		for (var i = 0; i < a.length; i++) {
			if( Iter.getValue(a[i], prop) == val ) out.push(a[i]);
		};
		return out;
	},
	remove: function(a, f){
		for (var i = 0; i < a.length; i++) {
			if( f(a[i], i, a) ) {a.splice(i, 1); return true;}
		};
		return false;
	},
	removeAll: function(a, f){
		for (var i = a.length-1; i >= 0; i--) {
			if( f(a[i], i, a) ) a.splice(i, 1);
		};
	},
	removeByVal: function(a, val){
		for (var i = 0; i < a.length; i++) {
			if( a[i] == val ) {a.splice(i, 1); return true;}
		};
		return false;
	},
	removeByProp: function(a, prop, val){
		for (var i = 0; i < a.length; i++) {
			if( Iter.getValue(a[i], prop) == val ) {a.splice(i, 1); return true;}
		};
		return false;
	},
	removeById: function(a, id){
		return Iter.removeByProp(a, "id", id);
	},
	removeAllByProp: function(a, prop, val){
		for (var i = a.length-1; i >= 0; i--) {
			if( Iter.getValue(a[i], prop) == val ) a.splice(i, 1);
		};
	},
	replaceByProp: function(a, prop, val, replaceItem){
		for (var i = 0; i < a.length; i++) {
			if( Iter.getValue(a[i], prop) == val ) {a.splice(i, 1, replaceItem); return;}
		};
		a.push(replaceItem);
	},
	replaceById: function(a, id, replaceItem){
		return Iter.replaceByProp(a, "id", id, replaceItem);
	},
	each: function(a, f){
		for (var i = 0; i < a.length; i++) {
			if( f(a[i], i, a) === false) return false;
		};
		return true;
	},
	eachProp: function(obj, f){
		for (var x in obj){
			if( f(obj[x], x, obj) === false) return false;
		}
		return true;
	},
	filter: function(a, f){
		var out = [];
		for (var i = 0; i < a.length; i++) {
			if( f(a[i], i, a) === true) out.push(a[i]);
		};
		return out;
	},
	filterObj: function(obj, f){
		var out = {};
		for (var prop in obj){
			if( f(obj, prop) === true ) out[prop] = obj[prop];
		}
		return out;
	},
	filterProps: function(obj, props){
		var out = {};
		for(var i = 0; i < props.length; i++){
			out[props[i]] = obj[props[i]];
		}
		return out;
	},
	map: function(a, f){
		var out = [];
		for (var i = 0; i < a.length; i++) {
			out.push( f(a[i], i, a) )
		};
		return out;
	},
	mapProp: function(a, prop){
		var out = [];
		for (var i = 0; i < a.length; i++) {
			out.push( Iter.getValue(a[i], prop) );
		};
		return out;
	},
	filterMap: function(a, f){
		var out = [], result;
		for (var i = 0; i < a.length; i++) {
			result = f(a[i], i, a);
			if(result !== undefined) out.push( result );
		};
		return out;
	},
	count: function(a, f){
		var count = 0;
		for(var i = 0; i < a.length; i++) {
			if( f(a[i], i, a) ) count++;
		}
		return count;
	},
	sum: function(a, f){
		var sum = 0;
		for(var i = 0; i < a.length; i++) {
			sum += f(a[i], i, a);
		}
		return sum;
	},
	sum: function(a, f){
		var sum = 0;
		for(var i = 0; i < a.length; i++) {
			sum += f(a[i], i, a);
		}
		return sum;
	},
	sumProp: function(a, prop){
		var sum = 0;
		for(var i = 0; i < a.length; i++) {
			sum += a[i][prop];
		}
		return sum;
	},
	range: function(min, max, interval){
		if(interval === undefined) interval = 1;
		if(max === undefined) max = min;
		var out = [];
		for(var i = min; i <= max; i+=interval){
			out.push(i);
		}
		return out;
	},
	truncate: function(str, max, sufix){
		sufix = sufix||"...";
		if(str.length <= max) return str;
		return str.substr(0, max) + sufix;
	},
	compareObjects: function(o1, o2){
	    for(var p in o1){
	        if(o1.hasOwnProperty(p)){
	            if(o1[p] !== o2[p]){
	                return false;
	            }
	        }
	    }
	    for(var p in o2){
	        if(o2.hasOwnProperty(p)){
	            if(o1[p] !== o2[p]){
	                return false;
	            }
	        }
	    }
	    return true;
	}
};